import { Pipe, PipeTransform } from '@angular/core'
import { fileSizeFormat } from '../../util'

@Pipe({ name: 'ftrFileSize', standalone: true })
export class FileSizePipe implements PipeTransform {
  transform(value: number, precision: number = 1): string {
    return fileSizeFormat(value, precision)
  }
}
